import { Routes, provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { ADMIN_ROUTES } from './admin/admin.routes';
import { AuthGuard } from './auth/auth.guard';
import { CLUBS_ROUTES } from './clubs/clubs.routes';
import { DEVELOP_ROUTES } from './develop/develop.routes';
import { OTHER_WELFARE_ROUTES } from './other-welware/other-welfare.routes';
import { SPRING_ACTIVITY_ROUTES } from './spring-activity/spring-activity.routes';
import { STORE_ROUTES } from './store/store.routes';
import { TOUR_GROUP_ROUTES } from './tour-group/tour-group.routes';
import { YEAR_END_BANQUET_ROUTES } from './year-end-banquet/year-end-banquet.routes';
// All feature components are now lazy loaded using loadComponent (standalone components)

const routes: Routes = [
  // {
  //   path: '',
  //   redirectTo: '/spring-activity/entry',
  //   pathMatch: 'full'
  // },
  {
    path: '',
    loadComponent: () => import('./shared/components/layouts/sidenav/sidenav.component').then(m => m.SidenavComponent),
    children: [
      {
        path: '',
        loadComponent: () => import('./entry/entry.component').then(m => m.EntryComponent),
        canActivate: [AuthGuard],
        data: { requireSignIn: false }
      }
    ]
  },
  {
    path: 'signin',
  loadComponent: () => import('./auth/sign-in/sign-in.component').then(m => m.SignInComponent),
    canActivate: [AuthGuard],
    data: { requireSignIn: false }
  },
  {
    path: 'ynrc',
  loadComponent: () => import('./year-end-banquet/banquet-check-in-receiver/banquet-check-in-receiver.component').then(m => m.BanquetCheckInReceiverComponent),
    canActivate: [AuthGuard],
    data: { requireSignIn: false}
  },
  {
    path: 'spn_rctk',
  loadComponent: () => import('./spring-activity/receive-activity-ticket/receive-activity-ticket.component').then(m => m.ReceiveActivityTicketComponent),
    canActivate: [AuthGuard],
    data: { requireSignIn: false }
  },
  {
    path: 'lklist',
    canActivate: [AuthGuard],
    data: { requireSignIn: true},
    children: [
      {
        path: '',
    loadComponent: () => import('./year-end-banquet/lucky-draw-manage/lucky-draw-list/lucky-draw-list.component').then(m => m.LuckyDrawListComponent),
      },
      {
        path: 'add',
        data: { mode: 'add' },
    loadComponent: () => import('./year-end-banquet/lucky-draw-manage/lucky-draw-dialog-route/lucky-draw-dialog-route.component').then(m => m.LuckyDrawDialogRouteComponent)
      },
      {
        path: ':giftId/edit',
        data: { mode: 'edit' },
    loadComponent: () => import('./year-end-banquet/lucky-draw-manage/lucky-draw-dialog-route/lucky-draw-dialog-route.component').then(m => m.LuckyDrawDialogRouteComponent)
      }
    ]
  },
  {
    path: 'bq-in',
    canActivate: [AuthGuard],
    data: { requireSignIn: false},
  loadComponent: () => import('./year-end-banquet/banquet-admin-entry/banquet-admin-entry.component').then(m => m.BanquetAdminEntryComponent)
  },
  {
    path: 'lkscn',
  loadComponent: () => import('./year-end-banquet/lucky-draw-scanner/lucky-draw-scanner.component').then(m => m.LuckyDrawScannerComponent),
    canActivate: [AuthGuard],
    data: { requireSignIn: false}
  },
  {
    path: 'lkaudit',
    loadComponent: () => import('./year-end-banquet/lucky-draw-manage/lucky-draw-audit-logs/lucky-draw-audit-logs.component').then(m => m.LuckyDrawAuditLogsComponent),
    canActivate: [AuthGuard],
    data: { requireSignIn: true }
  },
  {
    path: 'dwbrd',
  loadComponent: () => import('./year-end-banquet/drawing-info-board/drawing-info-board.component').then(m => m.DrawingInfoBoardComponent),
    canActivate: [AuthGuard],
    data: { requireSignIn: false}
  },
  {
    path: 'chkinadmin',
  loadComponent: () => import('./year-end-banquet/check-in-admin/check-in-admin.component').then(m => m.CheckInAdminComponent),
    canActivate: [AuthGuard],
    data: { requireSignIn: false}
  },
  {
    path: 'seating',
    loadComponent: () => import('./year-end-banquet/banquet-seating/banquet-seating.component').then(m => m.BanquetSeatingComponent),
    canActivate: [AuthGuard],
    data: { requireSignIn: true }
  },
  {
    path: 'seating/:year',
    loadComponent: () => import('./year-end-banquet/banquet-seating/banquet-seating.component').then(m => m.BanquetSeatingComponent),
    canActivate: [AuthGuard],
    data: { requireSignIn: true }
  },
  { path: 'tour_group', loadComponent: () => import('./shared/components/layouts/sidenav/sidenav.component').then(m => m.SidenavComponent), children: [...TOUR_GROUP_ROUTES] },
  { path: 'year-end-banquet', loadComponent: () => import('./shared/components/layouts/sidenav/sidenav.component').then(m => m.SidenavComponent), children: [...YEAR_END_BANQUET_ROUTES] },
  { path: 'clubs', loadComponent: () => import('./shared/components/layouts/sidenav/sidenav.component').then(m => m.SidenavComponent), children: [...CLUBS_ROUTES] },
  { path: 'other-welfare', loadComponent: () => import('./shared/components/layouts/sidenav/sidenav.component').then(m => m.SidenavComponent), children: [...OTHER_WELFARE_ROUTES] },
  { path: 'spring-activity', loadComponent: () => import('./shared/components/layouts/sidenav/sidenav.component').then(m => m.SidenavComponent), children: [...SPRING_ACTIVITY_ROUTES] },
  { path: 'store', loadComponent: () => import('./shared/components/layouts/sidenav/sidenav.component').then(m => m.SidenavComponent), children: [...STORE_ROUTES] },
  { path: 'admin', loadComponent: () => import('./shared/components/layouts/sidenav/sidenav.component').then(m => m.SidenavComponent), children: [...ADMIN_ROUTES] },
  { path: 'develop', loadComponent: () => import('./shared/components/layouts/sidenav/sidenav.component').then(m => m.SidenavComponent), children: [...DEVELOP_ROUTES] }
];

export const appRoutes: Routes = routes;
export const provideAppRouting = () => [provideRouter(appRoutes, withPreloading(PreloadAllModules))];
